<template>
  <div id="sovdetail">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="datepickerwrap card revampCard"
    style="flex-direction: row;">
      <div class="leftcontent wrapitem">
        <div class="datebox" style="width: 10%">
          <datepicker
            placeholder="From"
            @input="changeCustomDate"
            v-model="date.pStartDate"
            :disabled="date.disabled.pstart"
          />
        </div>
        <div class="datebox" style="width: 10%">
          <datepicker
            placeholder="From"
            @input="changeCustomDate"
            v-model="date.startDate"
            :disabled="date.disabled.pstart"
          />
        </div>
        <div class="datebox customSelect" style="width: 10%">
          <select
            @change="refresh"
            v-model="selected_website"
            class="form-control text-uppercase"
          >
            <option value="https://www.amazon.in">Amazon</option>
            <!-- <option value="https://www.flipkart.com">Flipkart</option> -->
          </select>
        </div>
        <div class="datebox customSelect" style="width: 13%">
          <select
            @change="icChanged"
            v-model="selectedItemCategory"
            class="form-control text-uppercase"
          >
            <option v-for="d in itemCategory" :value="d" :key="d.key">
              {{ d.value }}
            </option>
          </select>
        </div>
        <div class="datebox customSelect" style="width: 13%">
          <select
            @change="icChanged"
            v-model="dataType"
            class="form-control text-uppercase"
          >
            <option value="category">Category</option>
            <option value="search">Search</option>
          </select>
        </div>
        <div class="datebox" style="width: 10%">
          <button @click="icChanged" class="btn primarycolor" type="button">
            <span >Submit</span>
          </button>
        </div>
        <!-- <div class="datebox" style="width: 13%">
          <button @click="exportNow" class="ui button exportButton">Export</button>
        </div> -->
      </div>
      <div class="righcontent wrapitem">
        <div class="datebox" style="float: right">
          <button
            @click="backToSov"
            style="width: max-content; float: right"
            class="navigationButton"
            type="button"
          >
          <img src="Icons_SVG/Arrow_Left.svg" height="14" class="backIcon">
            <span> Back</span>
          </button>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="">
        <div class="card p-2 revampCard ">
          <div class="d-flex justify-content-end align-items-center">
            <div class="legending">
              <i class="fa fa-square" 
              style="color: var(--primary_client-20)!important; border-radius: 2px; margin-right: 2px;"
              ></i>
              <span>Rangita</span>
            </div>
            <button @click="exportNow" class="ui button exportButton" >Export</button>
          </div>
          <div class="mt-4">
          <table id="snapdeal-sovdetailedTable" class="table">
            <thead class="thead-normal">
              <tr>
                <th v-for="d in columns_details" :key="d.field">{{ d.label }}</th>
              </tr>
            </thead>
            <tfoot style="display: table-row-group">
              <tr>
                <th v-for="d in columns_details" :key="d.field">{{ d.label }}</th>
              </tr>
            </tfoot>
            <tbody class="tbody-normal">
              <tr
                v-for="(r, i) in rows_details"
                :key="i"
                :class="{ markitamd: r['brand'] == client }"
              >
                <td v-for="d in columns_details" :key="d.field">
                  <span v-if="d.field == 'product_name'">
                    <a target="_blank" :href="r['link']">{{ r[d.field] }}</a>
                  </span>
                  <span v-else>
                    <span v-if="r[d.field] != ''">
                      <span>{{ r[d.field] }}</span>
                    </span>
                    <span v-else>-</span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        </div>
        <!-- <div style="height: 80px"></div>   -->
      </div>
    </div>
    <b-modal size="lg" title="Audit" v-model="showAuditModal">
      <table id="sku" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th
              v-for="d in columnsAudit"
              :key="d.field"
              style="border: 1px solid silver !important"
            >
              {{ d.label }}
              <span v-if="d.field == 'compliance_score'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="(((Product Logo + OEM Images + Nomenclature + Message)/4)/3)*100"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'position_score'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="(100 - Category Position) 
                  if Category Position < 100,
                  0 if Category Position > 100"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'sku_score'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="(Compliance Score + Position Score + Rating Score)/3"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'rating_score'">
                <b-btn class="hint" v-b-tooltip.hover title="(Rating/5)*100">?</b-btn>
              </span>
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal">
          <tr v-for="(r, i) in rowsAudit" :key="i">
            <td
              v-for="d in columnsAudit"
              :key="d.field"
              style="border: 1px solid silver !important"
            >
              {{ r[d.field] }}
            </td>
          </tr>
        </tbody>
      </table>
      <h5 class="cust-head">Position Score</h5>
      <table id="position" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th
              v-for="d in columns_category"
              :key="d.field"
              style="border: 1px solid silver !important"
            >
              {{ d.label }}
              <span v-if="d.field == 'category_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position In Category Page"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'category_13_position'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="1: If System in page 1 of results
                  2: if System in page 2-3 of results
                  3: if System not in pages 1-3 "
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'search_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position in on-site search"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'search_13_position'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="1: If System in page 1 of search results
                  2: if System in page 2-3 of search results
                  3: if System not in pages 1-3 "
                  >?</b-btn
                >
              </span>
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal">
          <tr v-for="(r, i) in rowsAudit" :key="i">
            <td
              v-for="d in columns_category"
              :key="d.field"
              style="border: 1px solid silver !important"
            >
              <span> {{ r[d.field] }} </span>
            </td>
          </tr>
        </tbody>
      </table>

      <h5 class="cust-head">Compliance Score</h5>
      <table id="compliance" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th
              v-for="d in columns_compliance"
              :key="d.field"
              style="border: 1px solid silver !important"
            >
              {{ d.label }}
              <span v-if="d.field == 'logo'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="1: Correct AMD Badges
                  2: Incorrect AMD Badges
                  3: No AMD Badges"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'image_count'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="1: 3 or more product images
                  2: 2 more product images
                  3: 0 or 1 product images"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'nomenclature'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="1: Correct AMD Nomenclature
                  2: Incorrect AMD Nomenclature
                  3: No AMD Nomenclature"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'message'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="1: Correct AMD Messaging
                  2: Incorrect AMD Messaging
                  3: No AMD Messaging"
                  >?</b-btn
                >
              </span>
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal">
          <tr v-for="(r, i) in rowsAudit" :key="i">
            <td
              v-for="d in columns_compliance"
              :key="d.field"
              style="border: 1px solid silver !important"
            >
              <span> {{ r[d.field] }} </span>
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";

export default {
  name: "sovdetail",
  components: { Datepicker },
  watch: {
    selected_website: function () {
      let self = this;
      if (self.selected_website == "https://www.flipkart.com") {
        self.itemCategory = [{ key: "womens kurtas", value: "Women's Kurtas" }];
      } else {
        self.itemCategory = [{ key: "womens kurtas", value: "Women's Kurtas" }];
      }
      localStorage.demo_selected_website = this.selected_website;
    },
  },
  data: function () {
    return {
      selected_website: "https://www.amazon.in",
      date: {
        pStartDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
        startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
        disabled: {
          pstart: {
            to: moment("2023-01-17", "YYYY-MM-DD").toDate(),
          },
          start: {
            to: moment("2023-01-17", "YYYY-MM-DD").toDate(),
          },
        },
      },
      columns_details: [
        { label: "Rank", field: "order" },
        { label: "Page", field: "page" },
        { label: "Brand", field: "brand" },
        { label: "Name", field: "product_name", sortable: false },
        { label: "Original Price", field: "original_price", sortable: false },
        { label: "Discounted Price", field: "discount_price", sortable: false },
        { label: "Discount", field: "discount", sortable: false },
        { label: "Reviews", field: "reviews" },
        { label: "Ratings", field: "ratings" },
      ],
      rows: [],
      rows_details: [],
      page: 1,
      showAuditModal: false,
      columnsAudit: [
        { label: "SKU", field: "sku", sortable: false },
        { label: "Compliance Score", field: "compliance_score", sortable: false },
        { label: "Position Score", field: "position_score", sortable: false },
        { label: "Rating Score", field: "rating_score", sortable: false },
        { label: "SKU Score", field: "sku_score", sortable: false },
      ],
      columns_category: [
        { label: "Category Position", field: "category_position", sortable: false },
        {
          label: "Category page position (1-3)",
          field: "category_13_position",
          sortable: false,
        },
        { label: "Search Position", field: "search_position", sortable: false },
        { label: "Search (1-3) Position", field: "search_13_position", sortable: false },
      ],
      columns_compliance: [
        { label: "Product Logo", field: "logo", sortable: false },
        { label: "OEM Images", field: "image_count", sortable: false },
        { label: "Nomenclature", field: "nomenclature", sortable: false },
        { label: "Message", field: "message", sortable: false },
      ],
      rowsAudit: [],
      isHero: false,
      rows_details_full: [],
      loader: false,
      itemCategory: [],
      selectedItemCategory: {},
      client: JSON.parse(localStorage.reviewUserData).data.client,
      dataType: "category",
      icChangeOccur: false,
    };
  },
  mounted() {
    let self = this;
    // if(localStorage.philips_startDate) this.date.startDate = localStorage.philips_startDate
    // if(localStorage.philips_prevStartDate)  this.date.pStartDate = localStorage.philips_prevStartDate
    if (localStorage.demo_selected_website)
      this.selected_website = localStorage.demo_selected_website;

    if (self.selected_website == "https://www.flipkart.com") {
      self.itemCategory = [{ key: "womens kurtas", value: "Women's Kurtas" }];
    } else {
      self.itemCategory = [{ key: "womens kurtas", value: "Women's Kurtas" }];
    }
    if (localStorage.demo_selectedItemCategory) {
      this.selectedItemCategory = {};
      for (let [i, k] of this.itemCategory.entries()) {
        if (k.key == JSON.parse(localStorage.demo_selectedItemCategory).key) {
          this.selectedItemCategory = k;
        }
      }
      if (!Object.keys(this.selectedItemCategory).length) {
        this.selectedItemCategory = this.itemCategory[0];
      }
    } else self.selectedItemCategory = this.itemCategory[0];
    this.initCols();
  },
  methods: {
    exportNow() {
      let self = this;
      self.loader = true;
      const url = "/api/india_clinets/sov_detail_download";
      let payload = {
        item_category: "womens kurtas",
        start_date: self.date.pStartDate,
        end_date: self.date.startDate,
        website: "https://www.amazon.in",
        client: "rangita",
      };
      this.$http.post(url, payload).then(
        (response) => {
          self.loader = false;
          window.location = response.body.data;
        },
        (err) => {
          self.loader = false;
        }
      );
    },
    initCols() {
      this.columns_details = [
        { label: "Rank", field: "order" },
        { label: "Page", field: "page" },
        { label: "Brand", field: "brand" },
        { label: "Name", field: "product_name", sortable: false },
        { label: "Original Price", field: "original_price", sortable: false },
        { label: "Discounted Price", field: "discounted_price", sortable: false },
        { label: "Discount", field: "discount", sortable: false },
        { label: "Reviews", field: "reviews" },
        { label: "Ratings", field: "ratings" },
      ];
      if (this.date.pStartDate != this.date.startDate) {
        this.columns_details.splice(0, 2);
      }
      this.website_details();
    },
    icChanged() {
      this.icChangeOccur = true;
      localStorage.demo_selectedItemCategory = JSON.stringify(this.selectedItemCategory);
      this.refresh();
    },

    backToSov() {
      window.location = "#/sov-rangita";
    },
    showHeroChange() {
      let self = this;
      $("#snapdeal-sovdetailedTable").DataTable().destroy();
      this.rows_details = [];
      for (let [idx, dataset] of this.rows_details_full.entries()) {
        if (self.isHero) {
          if (dataset.is_hero) {
            this.rows_details.push(dataset);
          }
        } else this.rows_details.push(dataset);
      }
      this.$nextTick(function () {
        self.initDt2();
      });
    },

    openAuditModal(r) {
      let self = this;
      self.rowsAudit = [];
      self.showAuditModal = true;
      self.rowsAudit.push(r.audit);
    },

    format(v) {
      return this.$options.filters.format(v);
    },
    refresh() {
      let self = this;
      $("#snapdeal-sovdetailedTable").DataTable().destroy();
      if (!self.icChangeOccur) {
        this.selectedItemCategory = { key: "womens kurtas", value: "Women's Kurtas" };
        localStorage.demo_selectedItemCategory = JSON.stringify(
          this.selectedItemCategory
        );
      }
      self.icChangeOccur = false;
      this.initCols();
    },

    website_details() {
      let self = this;
      self.loader = true;
      this.rows_details = [];
      this.rows_details_full = [];
      const url = "/api/india_clients/product_website_details";
      let payload = {
        item_category: self.selectedItemCategory.key,
        start_date: self.date.pStartDate,
        end_date: self.date.startDate,
        website: self.selected_website,
        client: "rangita",
        data_type: self.dataType,
      };
      this.$http.post(url, payload).then(
        (response) => {
          let resData = response.body.data.data;
          for (let [idx, ds] of resData.entries()) {
            self.rows_details.push(ds);
            self.rows_details_full.push(ds);
          }
          self.loader = false;
          self.$nextTick(function () {
            self.initDt2();
          });
        },
        (err) => {
          self.loader = false;
          console.log(err);
          console.log("err");
        }
      );
    },

    changeCustomDate() {
      if (this.date.pStartDate)
        this.date.pStartDate = moment(this.date.pStartDate).format("YYYY-MM-DD");
      if (this.date.startDate)
        this.date.startDate = moment(this.date.startDate).format("YYYY-MM-DD");
      localStorage.philips_startDate = this.date.startDate;
      localStorage.philips_prevStartDate = this.date.pStartDate;
    },
    initDt2() {
      let self = this;
      $("#snapdeal-sovdetailedTable").DataTable({
        language: { 
          search: "",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: ""
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_"
        },
        pagingType: 'full_numbers',
        initComplete: function () {
          this.api()
            .columns()
            .every(function () {
              var column = this;
              var select = $("<select><option value=''>All</option></select>")
                .appendTo($(column.footer()).empty())
                .on("change", function () {
                  var val = $.fn.dataTable.util.escapeRegex($(this).val());
                  column.search(val ? "^" + val + "$" : "", true, false).draw();
                });
              let arr = [];
              let sortedArr = [];
              column
                .data()
                .unique()
                .sort()
                .each(function (d, j) {
                  var myVal = $(d).text();
                  arr.push(myVal);
                });

              sortedArr = arr.sort((a, b) =>
                a.localeCompare(b, navigator.languages[0] || navigator.language, {
                  numeric: true,
                  ignorePunctuation: true,
                })
              );
              for (let [idx, ds] of sortedArr.entries()) {
                select.append("<option value='" + ds + "'>" + ds + "</option>");
              }
            });
        },
      });

      var search = require('../../../public/Icons_SVG/Search.svg')
      $("#snapdeal-sovdetailedTable_filter > label > input").attr("placeholder", "Search");
      $("#snapdeal-sovdetailedTable_filter > label").append(`<div class='search_icon'><img src='${search}' /></div>`);
      // $("#snapdeal-sovdetailedTable_filter").prepend(`<div class='filter_icon'><img src='${funnel}' /></div>`);
      // $("#snapdeal-sovdetailedTable_filter > div.filter_icon").click(() => this.filterAddAction())
      $("#snapdeal-sovdetailedTable_length > label > select").removeClass();
    },
  },
};
</script>

<style>
#snapdeal-sovdetailedTable_filter > label{
  display: flex;
  flex-direction: row;
  justify-content: end;
}
#snapdeal-sovdetailedTable_filter input{
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}
#snapdeal-sovdetailedTable_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}
#snapdeal-sovdetailedTable_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}
#snapdeal-sovdetailedTable_filter input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}
#snapdeal-sovdetailedTable_filter input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}
#snapdeal-sovdetailedTable .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}
div#snapdeal-sovdetailedTable_filter{
  display: flex;
  justify-content: end;
}
#snapdeal-sovdetailedTable_filter div.search_icon{
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}
#snapdeal-sovdetailedTable_filter div.search_icon img{
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

#snapdeal-sovdetailedTable_filter div.filter_icon{
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  background-color: var(--background);
}
#snapdeal-sovdetailedTable_filter div.filter_icon img{
  height: 23px;
  filter: brightness(0) saturate(100%) invert(24%) sepia(18%) saturate(2530%) hue-rotate(138deg) brightness(98%) contrast(95%);
}

#snapdeal-sovdetailedTable_paginate {
  position: relative;
  top: 12px;
  z-index: 100;
  float: right;
  width: 50vw;
}
#snapdeal-sovdetailedTable_info{
  position: relative;
  top: 9px;
  left: 300px;
  z-index: 100;
  float: right;
  width: 50vw;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}
#snapdeal-sovdetailedTable_length {
  /* position: relative;
  top: 90px;
  left: 30px;
  z-index: 100;
  width: 50vw; */
}
#snapdeal-sovdetailedTable_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
}
#snapdeal-sovdetailedTable_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  color: var(--primary_brand-80);
  margin: 0;
}
#snapdeal-sovdetailedTable_length select {
  width: 30px;
  height: 100%;
  text-align-last:center;
  border-radius: 5px;
  margin-right: 10px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-color: var(--primary_brand-40) !important;
  background-color: #fff !important;
  color: var(--primary_brand-80);
}
#snapdeal-sovdetailedTable_paginate .page-link{
  border: none !important;
  background: none !important;
  color: var(--primary_brand-80) !important;
}
#snapdeal-sovdetailedTable_paginate ul.pagination li.active{
  border: 1px solid var(--primary_brand-40) !important;
  border-radius: 7px;
  box-shadow: none !important;
}
#snapdeal-sovdetailedTable{
  border-radius: 20px 20px 0 0;
}
#snapdeal-sovdetailedTable .thead-normal,#snapdeal-sovdetailedTable .thead-normal tr,#snapdeal-sovdetailedTable .thead-normal > tr > th:first-child{
  background-color: var(--background) !important;
  border-radius: 21px 0 0 0;
  border-left: 1px solid var(--base_color-20) !important;
}
#snapdeal-sovdetailedTable .thead-normal > tr > th:last-child{
  border-radius: 0 21px 0 0;
}
#snapdeal-sovdetailedTable .thead-normal > tr > th{
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 5px 25px;
  color: rgb(78 78 78) !important;
  border-top: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
}
#snapdeal-sovdetailedTable .thead-normal > tr > th.sorting:before {
  font-size: 15px;
  bottom: 57%;
  color: var(--base_color-80);
}
#snapdeal-sovdetailedTable .thead-normal > tr > th.sorting:after {
  /* top: -40%; */
  font-size: 15px;
  color: var(--base_color-80);
  
}
#snapdeal-sovdetailedTable th select {
    background-color: #fff !important;
    filter: brightness(99%);
    border: 1px solid #b1b1b1 !important;
    width: 100%;
    color: var(--primary_brand-60);
    font-size: 10px;
    border-radius: 7px;
    height: 33px;
}
#snapdeal-sovdetailedTable tfoot th{
  background-color: var(--background) !important;
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}
#snapdeal-sovdetailedTable tfoot th:first-child{
  background-color: var(--background) !important;
  border-left: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}
#snapdeal-sovdetailedTable tbody td{
  border-right: 1px solid var(--base_color-20) 
  !important;
  border-bottom: 1px solid var(--base_color-20) 
  !important;

  font-size: 13px !important;
  font-family: 'Heebo', sans-serif !important;
}

#snapdeal-sovdetailedTable tbody td:first-child{
  border-left: 1px solid var(--base_color-20) !important;
}
#snapdeal-sovdetailedTable .even td{
  /* background: #fff !important; */
}
#snapdeal-sovdetailedTable .odd td{
  /* background: #fff !important; */
  /* filter: brightness(110%); */
}

/* #snapdeal-sovdetailedTable_wrapper .bottom{
  margin: -30px;
} */
#snapdeal-sovdetailedTable_wrapper > .row:last-child{
  margin-bottom: 15px;
}
#snapdeal-sovdetailedTable_wrapper .scrolledDataTable{
  border-left: none;
  border-right: none;
}
#snapdeal-sovdetailedTable_wrapper .scrolledDataTable::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
	border-radius: 10px;
	background: var(--base_color-10);
}

#snapdeal-sovdetailedTable_wrapper .scrolledDataTable::-webkit-scrollbar
{
  height: 10px;
}

#snapdeal-sovdetailedTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background: var(--background);
}
#snapdeal-sovdetailedTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover
{
	background: var(--base_color-60);
}
</style>

<style scoped>
#sovdetail {
  font-family: "Poppins", sans-serif !important;
}
.checkbox-btn{
  margin-right: 6px;
  height: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  background-color: var(--base_color-10);
  border-radius: 5px;
  color: #000;
  padding: 0px 10px;
}
.checkbox-btn span{
  padding: 0 5px;
}
.checkbox-btn input{
  margin: 4px;
  font-size: 11px;
  width: 15px;
  height: 15px;
  accent-color: #fff;
}


.revampCard {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1.5rem;
}
.exportButton:hover {
  color: white !important;
  background: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}
select {
  font-family: "Poppins", sans-serif;
}
button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}
button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

button.green {
  background: var(--green);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}
button.green:hover {
  color: white;
  background: var(--green-80);
  /* border: 1.6px solid var(--base_color); */
}

button.red {
  background: var(--red);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}
button.red:hover {
  color: white;
  background: var(--red-80);
  /* border: 1.6px solid var(--base_color); */
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}
.navigationButton:hover {
  background: var(--accent_color-80);
}

.form-control{
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

.exportButton {
  margin-left: 6px;
  height: 35px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px;
  font-weight: 600;
  padding: 0px 25px;
  letter-spacing: 0.2px;
}
.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  margin-bottom: -20px !important ;
}
.backIcon {
  filter: brightness(0) saturate(100%) invert(98%) sepia(0%) saturate(206%) hue-rotate(268deg) brightness(116%) contrast(100%);
}

input.textInput{
  border-radius: 5px !important;
  outline: none;
}
input.textInput:focus{
  border-color: var(--primary_brand-60) !important;
  outline: none !important;
  box-shadow: none !important;
}

/* pre-revamp styles */
.custom-table {
  padding: 10px;
  margin: 10px;
}

.markitamd
{
  background-color: var(--primary_client-20) !important
}
.markitintel {
  background-color: #c7e0ff !important;
}
.markitsnap {
  background-color: #ffd0f5 !important;
}
.markitna {
  background-color: #edf2fb !important;
}
.markittek {
  background-color: #fff0ce !important;
}
.space-between-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;
  padding-left: 5px;
  padding-right: 7px;
  padding-bottom: 5px;
}
.space-between-header select {
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}
.space-between-header h3 {
  color: #533a79;
  margin-bottom: 0;
  line-height: 31px;
}
.listing-custom {
  font-size: 18px;
  margin-bottom: 6px;
  text-align: center;
  width: 215px;
  background: #8a87e8;
}
.hint {
  cursor: pointer;
  background: #f5f5f5;
  color: #080808;
  padding: 3px;
  font-size: 9px;
}
.amd-legend {
  text-align: center;
  position: absolute;
  left: 15%;
  right: 15%;
  z-index: 999;
}
.amd-legend i {
  width: fit-content;
}
.amd-legend span {
  padding-left: 4px;
  font-size: 12px;
}
.legending {
  display: inline-block;
  margin-right: 19px;
}
#avgTable th,
#avgTable td {
  border: 1px solid #c8ced3 !important;
  text-align: left;
  font-size: 14px;
}
.mycols:first-child {
  padding-right: 2px !important;
}
.mycols:last-child {
  padding-left: 2px;
}
.mycols:not(:first-child):not(:last-child) {
  padding-left: 2px;
  padding-right: 2px;
}
</style>
